import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AccessRightService } from './access-right.service';
import { DetectDevicesService } from './detect-devices.service';
import { FiChecklistService } from './fi-checklist.service';
import { FiCustomerDataService } from './fi-customer-data.service';
import { FiTagsService } from './fi-tags.service';
import { FiUserDataService } from './fi-user-data.service';
import { PostService } from './post.service';
import { FiSnackBarService } from '../fi-snackbar/snack-bar.service';
import { UserSearchService } from './user-search.service';
import { FiScrollToElementAnimateService } from '@fi-shared/fi-shared-services/scroll-to-element-animate.service';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { FiErrorMessageSharedService } from '@fi-shared/fi-shared-services/fi-error-message-shared.service';
import { FiDebugInfoService } from '@fi-shared/fi-shared-services/fi-debug-info.service';
import { FiLogErrorService } from '@fi-shared/fi-shared-services/fi-log-error.service';
import { FileTypeService } from '@fi-shared/fi-shared-services/file-type.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { UserPreferencesService } from '@fi-shared/fi-shared-services/user-preferences.service';
import { FiItemsDeleteHelperService } from '@fi-shared/fi-shared-services/fi-items-delete-helper.service';
import { FiRequestsQueueService } from '@fi-shared/fi-shared-services/fi-requests-queue.service';
import { FiFavoritesService } from '@fi-shared/fi-shared-services/fi-favorites.service';
import { FiSiteDesignService } from '@fi-shared/fi-shared-services/fi-site-design.service';
import { ExtensionsService } from '@fi-shared/fi-shared-services/extensions.service';
import { FiItemsEditHelperService } from '@fi-shared/fi-shared-services/fi-items-edit-helper.service';
import { FiAccessRightHelperService } from '@fi-shared/fi-shared-services/fi-access-right-helper.service';
import { FiCommonSharedService } from '@fi-shared/fi-shared-services/fi-common-shared.service';
import { FiTimeZonesService } from '@fi-shared/fi-shared-services/fi-time-zones.service';
import { SiteMapHelperService } from '@fi-shared/fi-shared-services/site-map-helper.service';
import { TextTruncationService } from './text-truncation.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, MatSnackBarModule],
    providers: [
        AccessRightService,
        AccessToApplicationTypeService,
        StateAccessCheckService,
        DetectDevicesService,
        ExtensionsService,
        FiChecklistService,
        FiCustomerDataService,
        FiTagsService,
        FiUserDataService,
        FiFavoritesService,
        PostService,
        FiSnackBarService,
        UserSearchService,
        FiScrollToElementAnimateService,
        FiBrowserEventsService,
        FiErrorMessageSharedService,
        FiDebugInfoService,
        FiLogErrorService,
        FileTypeService,
        SaveChangesWarningService,
        UserPreferencesService,
        FiItemsDeleteHelperService,
        FiItemsEditHelperService,
        FiRequestsQueueService,
        FiSiteDesignService,
        FiCommonSharedService,
        FiTimeZonesService,
        FiAccessRightHelperService,
        SiteMapHelperService,
        TextTruncationService,
    ],
})
export class FiSharedServicesModule {}
